<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1400px">
    <v-card v-if="customer">
      <v-card-title>
        <span class="text-h5">{{ customer.company }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            
            <CustomerInfo
              :customer="customer"
              :interest-options="conservationStatusOptions"
              :conservation-statuses="conservationStatuses"

              @update="handleCustomerUpdate"
              @fieldUpdate="handleFieldUpdate"            
            />

          
            <ContactPersonsList
              :contact-persons="contactPersons"
              class="mt-4"
              @add="openContactPersonDialog"
              @edit="openContactPersonDialog"
              @email="handleContactEmail"
            />
          </v-col>

          <v-col cols="12" md="8">
            <ConversationsList
              :customer="customer"
              :conversations="conversations"
              :contact-persons="contactPersons"
              @openConversation="handleOpenConversation"
              @openEmail="handleOpenEmail"
              @editNote="handleEditNote"
              @deleteConversation="handleDeleteConversation"
              @save="handleConversationSave"
              
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomerInfo from '@/components/CustomerInfo.vue'
import ContactPersonsList from '@/components/ContactPersonsList.vue'
import ConversationsList from '@/components/ConversationsList.vue'

export default {
  name: 'CustomerDetailDialog',
  
  components: {
    CustomerInfo,
    ContactPersonsList,
    ConversationsList
  },

  props: {
    value: Boolean,
    customer: Object,
    conversations: Array,
    contactPersons: Array,
    conservationStatuses: { 
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      conversationFilter: null,
      editingConversationId: null,
      editingConversationNote: '',

      interestOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
        { text: 'Unknown', value: 'unknown' },
        { text: 'Later', value: 'later' }
      ]
    }
  },

  computed: {
    filteredConversations() {
      let filtered = this.conversationFilter 
        ? this.conversations.filter(c => c.contact_person_id === this.conversationFilter)
        : [...this.conversations]
      
      return filtered.sort((a, b) => {
        const dateA = new Date(a.created_at || 0)
        const dateB = new Date(b.created_at || 0)
        return dateB - dateA
      })
    },

    conversationFilterOptions() {
      const options = [{ text: 'All Conversations', value: null }]
      this.contactPersons.forEach(contact => {
        options.push({
          text: contact.name,
          value: contact.id
        })
      })
      return options
    },
    conservationStatusOptions() {
      if (!this.conservationStatuses || this.conservationStatuses.length === 0) {
        return this.interestOptions
      }

      return this.conservationStatuses.map(status => ({
        text: status.label_text,
        value: status.keyword,
        color: status.color
      }))
    }
  },

  methods: {

    formatNoteForDisplay(note) {
      if (!note) return ''
      return note.replace(/\[NEWLINE\]/g, '\n').replace(/\nn/g, '\n')
    },
    handleConversationSave(conversationData) {
      this.$emit('save', conversationData)
    },
    async handleDeleteConversation(conversation) {
      this.$emit('delete-conversation', conversation)
    },
    
    close() {
      this.$emit('input', false)
    },

    async handleCustomerUpdate(updatedData) {
      console.log('CustomerDetailDialog: Updating customer with:', updatedData)
      try {
       
        this.$emit('update-customer', {
          customerId: this.customer.id,
          updateData: updatedData
        })
      } catch (error) {
        console.error('Error in CustomerDetailDialog:', error)
        alert('Error updating customer information')
      } 
    },

    
    // async handleFieldUpdate({ field, value }) {
    //   console.log('CustomerDetailDialog: Updating field:', field, 'to:', value)
    //   try {
    //     this.$emit('fieldUpdate', { field, value })
    //   } catch (error) {
    //     console.error('Error in CustomerDetailDialog field update:', error)
    //     alert('Error updating customer field')
    //   }
    // },

    openContactPersonDialog(contactPerson = null) {
      this.$emit('open-contact-person', contactPerson)
    },
  
    handleOpenConversation(customer) {
     this.$emit('open-conversation', customer)
    },
  
    handleOpenEmail(customer) {
      this.$emit('open-email', customer)
    },
  
    handleEditNote({ conversation, note }) {
      this.$emit('edit-note', { conversation, note })
    },
    
    handleContactEmail(contact) {
      this.$emit('open-email', this.customer, contact)
    },
  }
}
</script>